import { assets, staticAssets } from '@/config/assets';

export default {
  install: app => {
    app.config.globalProperties.$assets = assets;
    app.config.globalProperties.$staticAssets = staticAssets;

    app.provide('assets', assets);
    app.provide('staticAssets', staticAssets);
  }
};
